import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

const MODELS = [
  { label: 'Aion-2.0', value: 'aion-labs/aion-2.0' },
  { label: 'Aion-3.0', value: 'aion-labs/aion-3.0' },
  { label: 'Aion-3.0 Mini', value: 'aion-labs/aion-3.0-mini' },
  { label: 'Aion-3.5', value: 'aion-labs/aion-3.5' },
  { label: 'Aion-3.5 Mini', value: 'aion-labs/aion-3.5-mini' },
  { label: 'ChatGPT 4.1', value: 'openai/gpt-4.1' },
  { label: 'ChatGPT 4o (05/13/24)', value: 'openai/gpt-4o-2024-05-13' },
  { label: 'ChatGPT 4o (08/06/24)', value: 'openai/gpt-4o-2024-08-06' },
  { label: 'ChatGPT 4o (11/20/24)', value: 'openai/gpt-4o-2024-11-20' },
  { label: 'ChatGPT 5.1', value: 'openai/gpt-5.1' },
  { label: 'ChatGPT 5.4', value: 'openai/gpt-5.4' },
  { label: 'ChatGPT 5.4 Nano', value: 'openai/gpt-5.4-nano' },
  { label: 'ChatGPT 5.5', value: 'openai/gpt-5.5' },
  { label: 'ChatGPT 5.6', value: 'openai/gpt-5.6' },
  { label: 'ChatGPT o3', value: 'openai/o3' },
  { label: 'Claude Haiku', value: 'anthropic/claude-haiku-4.5' },
   { label: 'Claude Opus 4.5', value: 'anthropic/claude-opus-4.5' },
   { label: 'Claude Opus 4.6', value: 'anthropic/claude-opus-4.6' },
  { label: 'Claude Opus 4.7', value: 'anthropic/claude-opus-4.7' },
  { label: 'Claude Opus 4.8', value: 'anthropic/claude-opus-4.8' },
  { label: 'Claude Sonnet 4.5', value: 'anthropic/claude-sonnet-4.5' },
  { label: 'Claude Sonnet 4.6', value: 'anthropic/claude-sonnet-4.6' },
  { label: 'DeepSeek V3.2', value: 'deepseek/deepseek-v3.2' },
  { label: 'DeepSeek V4 Flash', value: 'deepseek/deepseek-v4-flash' },
  { label: 'DeepSeek V4 Pro', value: 'deepseek/deepseek-v4-pro' },
  { label: 'Gemini 3.5 Flash', value: 'google/gemini-3.5-flash' },
  { label: 'Gemma 4 26B', value: 'google/gemma-4-26b-a4b-it' },
  { label: 'GLM 4.7', value: 'z-ai/glm-4.7' },
  { label: 'GLM 5', value: 'z-ai/glm-5' },
  { label: 'GLM 5.1', value: 'z-ai/glm-5.1' },
  { label: 'GLM 5.2', value: 'z-ai/glm-5.2' },
  { label: 'Grok 4.20', value: 'x-ai/grok-4.20' },
  { label: 'Grok 4.3', value: 'x-ai/grok-4.3' },
  { label: 'Kimi K2 Thinking', value: 'moonshotai/kimi-k2-thinking' },
  { label: 'Kimi K2.5', value: 'moonshotai/kimi-k2.5' },
  { label: 'Kimi K2.6', value: 'moonshotai/kimi-k2.6' },
  { label: 'Kimi K3', value: 'moonshotai/kimi-k3' },
  { label: 'Mimo V2 Flash', value: 'xiaomi/mimo-v2-flash' },
  { label: 'Mimo V2 Pro', value: 'xiaomi/mimo-v2-pro' },
  { label: 'Mimo V2.5', value: 'xiaomi/mimo-v2.5' },
  { label: 'Mimo V2.5 Pro', value: 'xiaomi/mimo-v2.5-pro' },
  { label: 'Qwen3.6 35B A3B', value: 'qwen/qwen3.6-35b-a3b' },
];

const CONTEXT_LIMITS = [
  { label: '15 messages', value: '15' },
  { label: '20 messages', value: '20' },
  { label: '25 messages', value: '25' },
  { label: '30 messages', value: '30' },
  { label: '50 messages', value: '50' },
  { label: '75 messages', value: '75' },
  { label: '100 messages', value: '100' },
];

function CropModal({ imageSrc, onConfirm, onCancel }) {
  const canvasRef = useRef(null);
  const [offset, setOffset] = useState({ x: 0, y: 0 });
  const [scale, setScale] = useState(1);
  const [dragging, setDragging] = useState(false);
  const [lastPos, setLastPos] = useState(null);
  const imgRef = useRef(null);
  const SIZE = 280;

  useEffect(() => {
    const img = new Image();
    img.onload = () => {
      imgRef.current = img;
      const s = Math.max(SIZE / img.width, SIZE / img.height);
      setScale(s);
      setOffset({ x: (SIZE - img.width * s) / 2, y: (SIZE - img.height * s) / 2 });
    };
    img.src = imageSrc;
  }, [imageSrc]);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas || !imgRef.current) return;
    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, SIZE, SIZE);
    ctx.drawImage(imgRef.current, offset.x, offset.y, imgRef.current.width * scale, imgRef.current.height * scale);
    ctx.beginPath();
    ctx.arc(SIZE / 2, SIZE / 2, SIZE / 2, 0, Math.PI * 2);
    ctx.strokeStyle = 'rgba(201,147,90,0.6)';
    ctx.lineWidth = 2;
    ctx.stroke();
  }, [offset, scale]);

  const getPos = (e) => {
    const touch = e.touches?.[0];
    return { x: touch ? touch.clientX : e.clientX, y: touch ? touch.clientY : e.clientY };
  };

  const lastPinchDist = useRef(null);

  const onStart = (e) => {
    if (e.touches?.length === 2) return;
    setDragging(true);
    setLastPos(getPos(e));
  };
  const onMove = (e) => {
    if (e.touches?.length === 2) {
      const dx = e.touches[0].clientX - e.touches[1].clientX;
      const dy = e.touches[0].clientY - e.touches[1].clientY;
      const dist = Math.sqrt(dx * dx + dy * dy);
      if (lastPinchDist.current !== null) {
        const delta = dist - lastPinchDist.current;
        setScale(prev => Math.max(0.3, Math.min(5, prev + delta * 0.005)));
      }
      lastPinchDist.current = dist;
      return;
    }
    if (!dragging || !lastPos) return;
    const pos = getPos(e);
    setOffset(prev => ({ x: prev.x + pos.x - lastPos.x, y: prev.y + pos.y - lastPos.y }));
    setLastPos(pos);
  };
  const onEnd = () => {
    setDragging(false);
    setLastPos(null);
    lastPinchDist.current = null;
  };

  const onWheel = (e) => {
    e.preventDefault();
    setScale(prev => Math.max(0.3, Math.min(5, prev - e.deltaY * 0.001)));
  };

  const confirm = () => {
    const canvas = document.createElement('canvas');
    canvas.width = SIZE;
    canvas.height = SIZE;
    const ctx = canvas.getContext('2d');
    ctx.beginPath();
    ctx.arc(SIZE / 2, SIZE / 2, SIZE / 2, 0, Math.PI * 2);
    ctx.clip();
    ctx.drawImage(imgRef.current, offset.x, offset.y, imgRef.current.width * scale, imgRef.current.height * scale);
    canvas.toBlob(blob => onConfirm(blob), 'image/jpeg', 0.92);
  };

  return (
    <div style={cropStyles.overlay}>
      <div style={cropStyles.modal}>
        <div style={cropStyles.title}>drag to adjust ♡</div>
        <div style={cropStyles.hint}>drag to reposition • pinch or scroll to zoom</div>
        <div style={cropStyles.canvasWrap}>
          <canvas
            ref={canvasRef}
            width={SIZE}
            height={SIZE}
            style={cropStyles.canvas}
            onMouseDown={onStart}
            onMouseMove={onMove}
            onMouseUp={onEnd}
            onMouseLeave={onEnd}
            onTouchStart={onStart}
            onTouchMove={onMove}
            onTouchEnd={onEnd}
            onWheel={onWheel}
          />
        </div>
        <div style={cropStyles.actions}>
          <button style={cropStyles.cancelBtn} onClick={onCancel}>cancel</button>
          <button style={cropStyles.confirmBtn} onClick={confirm}>use photo ♡</button>
        </div>
      </div>
    </div>
  );
}

const cropStyles = {
  overlay: {
    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
    background: 'rgba(0,0,0,0.85)', zIndex: 200,
    display: 'flex', alignItems: 'center', justifyContent: 'center',
  },
  modal: {
    background: '#1e1825', borderRadius: '24px',
    border: '1px solid rgba(201,147,90,0.15)',
    padding: '28px 24px', display: 'flex',
    flexDirection: 'column', alignItems: 'center', gap: '16px',
    width: '340px',
  },
  title: { fontFamily: "'Cormorant Garamond', serif", fontSize: '20px', color: '#e8ddd0', fontWeight: '300', fontStyle: 'italic' },
  hint: { fontSize: '12px', color: '#4a3d30', fontWeight: '300' },
  canvasWrap: { borderRadius: '50%', overflow: 'hidden', boxShadow: '0 0 0 2px rgba(201,147,90,0.2)' },
  canvas: { display: 'block', cursor: 'grab', touchAction: 'none' },
  actions: { display: 'flex', gap: '12px', width: '100%' },
  cancelBtn: { flex: 1, padding: '13px', borderRadius: '14px', border: '1px solid rgba(201,147,90,0.15)', background: 'transparent', color: '#4a3d30', fontFamily: "'DM Sans', sans-serif", fontSize: '13px', cursor: 'pointer' },
  confirmBtn: { flex: 1, padding: '13px', borderRadius: '14px', border: 'none', background: 'linear-gradient(135deg, #8a5f35, #c9935a)', color: '#0e0b0f', fontFamily: "'DM Sans', sans-serif", fontSize: '13px', cursor: 'pointer' },
};

function ChatSettings() {
  const [companion, setCompanion] = useState(null);
  const [companionName, setCompanionName] = useState('');
  const [characterPrompt, setCharacterPrompt] = useState('');
  const [userPrompt, setUserPrompt] = useState('');
  const [stylePrompt, setStylePrompt] = useState('');
  const [model, setModel] = useState('');
  const [voiceId, setVoiceId] = useState('');
  const [memoryEnabled, setMemoryEnabled] = useState(true);
  const [contextLimit, setContextLimit] = useState('100');
  const [memories, setMemories] = useState([]);
  const [memoriesLoaded, setMemoriesLoaded] = useState(false);
  const [loadingMemories, setLoadingMemories] = useState(false);
  const [toast, setToast] = useState('');
  const [avatarPreview, setAvatarPreview] = useState(null);
  const [cropSrc, setCropSrc] = useState(null);
  const [saving, setSaving] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [voiceAutoSend, setVoiceAutoSend] = useState(false);
  const [voiceStability, setVoiceStability] = useState(50);
  const [voiceSimilarity, setVoiceSimilarity] = useState(75);
  const [voiceStyle, setVoiceStyle] = useState(0);
  const [voiceSpeed, setVoiceSpeed] = useState(1.0);
  const { companionId } = useParams();
  const navigate = useNavigate();
  const token = localStorage.getItem('token');

  useEffect(() => {
    fetchCompanion();
    setVoiceAutoSend(localStorage.getItem(`voiceAutoSend_${companionId}`) === 'true');
  }, []);

  const showToast = (msg) => {
    setToast(msg);
    setTimeout(() => setToast(''), 2500);
  };

  const fetchCompanion = async () => {
    try {
      const res = await axios.get(`${API}/companions?token=${token}`);
      const found = res.data.companions.find(c => c.id === companionId);
      if (found) {
        setCompanion(found);
        setCompanionName(found.name || '');
        setCharacterPrompt(found.chat_prompt || '');
        setUserPrompt(found.user_prompt || '');
        setStylePrompt(found.style_prompt || '');
        setModel(found.model || MODELS[0].value);
        setVoiceId(found.voice_id || '');
        setMemoryEnabled(found.memory_enabled !== false);
        setContextLimit(found.context_limit || '100');
        setVoiceStability(Math.round((found.voice_stability ?? 0.5) * 100));
        setVoiceSimilarity(Math.round((found.voice_similarity ?? 0.75) * 100));
        setVoiceStyle(Math.round((found.voice_style ?? 0.0) * 100));
        setVoiceSpeed(found.voice_speed ?? 1.0);
      }
    } catch(err) { console.log(err); }
  };

  const fetchMemories = async () => {
    setLoadingMemories(true);
    try {
      const res = await axios.get(`${API}/memories/${companionId}?token=${token}`);
      setMemories(res.data.memories || []);
      setMemoriesLoaded(true);
    } catch(err) { showToast('something went wrong 🥀'); }
    setLoadingMemories(false);
  };

  const savePrompts = async () => {
    setSaving(true);
    try {
      await axios.put(`${API}/companions/${companionId}`, {
        token, name: companionName, chat_prompt: characterPrompt,
        user_prompt: userPrompt, style_prompt: stylePrompt,
      });
      setCompanion(prev => ({ ...prev, name: companionName }));
      showToast('saved ♡');
    } catch(err) { showToast('something went wrong 🥀'); }
    setSaving(false);
  };

  const saveModel = async (newModel) => {
    setModel(newModel);
    try {
      await axios.put(`${API}/companions/${companionId}`, { token, model: newModel });
      showToast('model updated ♡');
    } catch(err) { console.log(err); }
  };

  const saveContextLimit = async (newLimit) => {
    setContextLimit(newLimit);
    try {
      await axios.put(`${API}/companions/${companionId}`, { token, context_limit: newLimit });
      showToast('context limit updated ♡');
    } catch(err) { console.log(err); }
  };

  const saveVoiceSettings = async (stability, similarity, style, speed) => {
    try {
      await axios.put(`${API}/companions/${companionId}`, {
        token,
        voice_stability: stability / 100,
        voice_similarity: similarity / 100,
        voice_style: style / 100,
        voice_speed: speed,
      });
      showToast('voice settings saved ♡');
    } catch(err) { console.log(err); }
  };

  const saveVoice = async () => {
    try {
      await axios.put(`${API}/companions/${companionId}`, { token, voice_id: voiceId });
      showToast('voice updated ♡');
    } catch(err) { console.log(err); }
  };

  const toggleMemory = async () => {
    const newValue = !memoryEnabled;
    setMemoryEnabled(newValue);
    try {
      await axios.put(`${API}/companions/${companionId}`, { token, memory_enabled: newValue });
      showToast(newValue ? 'memory on ♡' : 'memory off');
    } catch(err) {
      setMemoryEnabled(!newValue);
      showToast('something went wrong 🥀');
    }
  };

  const deleteMemory = async (memoryId, index) => {
    try {
      await axios.delete(`${API}/memories/${companionId}/${memoryId}?token=${token}`);
    } catch(err) {}
    setMemories(prev => prev.filter((_, i) => i !== index));
    showToast('memory removed ♡');
  };

  const clearMemories = async () => {
    try {
      await axios.delete(`${API}/memory/${companionId}?token=${token}`);
      setMemories([]);
      showToast('all memories cleared');
    } catch(err) { console.log(err); }
  };

  const toggleVoiceAutoSend = () => {
    const newValue = !voiceAutoSend;
    setVoiceAutoSend(newValue);
    localStorage.setItem(`voiceAutoSend_${companionId}`, String(newValue));
    showToast(newValue ? 'auto-send on ♡' : 'auto-send off');
  };

  const deleteCompanion = async () => {
    try {
      await axios.delete(`${API}/companions/${companionId}?token=${token}`);
      navigate('/companions/list');
    } catch(err) { showToast('something went wrong 🥀'); }
  };

  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (ev) => setCropSrc(ev.target.result);
    reader.readAsDataURL(file);
    e.target.value = '';
  };

  const handleCropConfirm = async (blob) => {
    setCropSrc(null);
    const objectUrl = URL.createObjectURL(blob);
    setAvatarPreview(objectUrl);
    showToast('uploading… ♡');
    try {
      const formData = new FormData();
      formData.append('file', blob, 'avatar.jpg');
      const res = await axios.post(
        `${API}/companions/${companionId}/avatar?token=${token}`,
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );
      setCompanion(prev => ({ ...prev, avatar_url: res.data.avatar_url }));
      setAvatarPreview(null);
      showToast('avatar updated ♡');
    } catch(err) {
      setAvatarPreview(null);
      showToast('upload failed 🥀');
    }
  };

  const currentAvatar = avatarPreview || companion?.avatar_url;

  return (
    <div style={styles.container}>
      {cropSrc && (
        <CropModal imageSrc={cropSrc} onConfirm={handleCropConfirm} onCancel={() => setCropSrc(null)} />
      )}

      <div style={styles.header}>
        <button style={styles.backBtn} onClick={() => navigate(-1)}>←</button>
        <div style={styles.headerTitle}>companion settings</div>
      </div>

      <div style={styles.content}>

        <div style={styles.section}>
          <div style={styles.sectionLabel}>companion</div>
          <div style={styles.companionCard}>
            <div style={styles.avatarWrap} onClick={() => document.getElementById('avatarInput').click()}>
              <div style={styles.avatar}>
                {currentAvatar
                  ? <img src={currentAvatar} alt="avatar" style={styles.avatarImg} />
                  : companionName?.[0] || 'C'
                }
              </div>
              <div style={styles.avatarUploadBtn}>📷</div>
              <input type="file" id="avatarInput" style={{ display: 'none' }} accept="image/*" onChange={handleFileSelect} />
            </div>
            <div style={styles.companionInfo}>
              <input style={styles.nameInput} value={companionName} onChange={e => setCompanionName(e.target.value)} placeholder="companion name" />
              <div style={styles.companionSub}>tap photo to change ♡</div>
            </div>
          </div>
        </div>

        <div style={styles.divider} />

        <div style={styles.section}>
          <div style={styles.sectionLabel}>character</div>
          <div style={styles.promptHint}>who are they? personality, backstory, how they feel about you, their mannerisms...</div>
          <textarea style={styles.promptBox} value={characterPrompt} onChange={e => setCharacterPrompt(e.target.value)} placeholder="Describe who they are..." />
        </div>

        <div style={styles.section}>
          <div style={styles.sectionLabel}>about you</div>
          <div style={styles.promptHint}>your name, your appearance, your relationship, your roleplay persona if any...</div>
          <textarea style={styles.promptBox} value={userPrompt} onChange={e => setUserPrompt(e.target.value)} placeholder="Write about yourself..." />
        </div>

        <div style={styles.section}>
          <div style={styles.sectionLabel}>writing style</div>
          <div style={styles.promptHint}>how do you want them to write? perspective, tense, length, tone, pet names...</div>
          <textarea style={styles.promptBox} value={stylePrompt} onChange={e => setStylePrompt(e.target.value)} placeholder="Describe how you want them to write..." />
        </div>

        <button style={{ ...styles.saveBtn, opacity: saving ? 0.7 : 1 }} onClick={savePrompts} disabled={saving}>
          {saving ? 'saving…' : 'save ♡'}
        </button>

        <div style={styles.divider} />

        <div style={styles.section}>
          <div style={styles.sectionLabel}>AI model</div>
          <div style={styles.modelWrap}>
            <select style={styles.modelSelect} value={model} onChange={e => saveModel(e.target.value)}>
              {MODELS.map(m => <option key={m.value} value={m.value}>{m.label}</option>)}
            </select>
            <div style={styles.modelArrow}>▾</div>
          </div>
        </div>

        <div style={styles.divider} />

        <div style={styles.section}>
          <div style={styles.sectionLabel}>context window</div>
          <div style={styles.promptHint}>how many recent messages to include in each request</div>
          <div style={styles.modelWrap}>
            <select style={styles.modelSelect} value={contextLimit} onChange={e => saveContextLimit(e.target.value)}>
              {CONTEXT_LIMITS.map(c => <option key={c.value} value={c.value}>{c.label}</option>)}
            </select>
            <div style={styles.modelArrow}>▾</div>
          </div>
        </div>

        <div style={styles.divider} />

        <div style={styles.section}>
          <div style={styles.sectionLabel}>elevenlabs voice ID</div>
          <div style={styles.voiceRow}>
            <input style={styles.voiceInput} placeholder="paste your elevenlabs voice ID here" value={voiceId} onChange={e => setVoiceId(e.target.value)} />
            <button style={styles.voiceSaveBtn} onClick={saveVoice}>save</button>
          </div>
        </div>

        <div style={styles.divider} />

        <div style={styles.section}>
          <div style={styles.sectionLabel}>voice settings</div>
          <div style={styles.promptHint}>adjust how the voice sounds — changes apply to new audio generations</div>

          {[
            { label: 'stability', value: voiceStability, setValue: setVoiceStability, min: 1, max: 100, step: 1, display: `${voiceStability}%` },
            { label: 'similarity', value: voiceSimilarity, setValue: setVoiceSimilarity, min: 1, max: 100, step: 1, display: `${voiceSimilarity}%` },
            { label: 'style exaggeration', value: voiceStyle, setValue: setVoiceStyle, min: 0, max: 100, step: 1, display: `${voiceStyle}%` },
            { label: 'speed', value: voiceSpeed, setValue: setVoiceSpeed, min: 0.70, max: 1.20, step: 0.01, display: `${voiceSpeed.toFixed(2)}x` },
          ].map(({ label, value, setValue, min, max, step, display }) => (
            <div key={label} style={styles.sliderWrap}>
              <div style={styles.sliderHeader}>
                <div style={styles.sliderLabel}>{label}</div>
                <div style={styles.sliderValue}>{display}</div>
              </div>
              <input
                type="range"
                min={min}
                max={max}
                step={step}
                value={value}
                onChange={e => setValue(label === 'speed' ? parseFloat(e.target.value) : parseInt(e.target.value))}
                onMouseUp={() => saveVoiceSettings(voiceStability, voiceSimilarity, voiceStyle, voiceSpeed)}
                onTouchEnd={() => saveVoiceSettings(voiceStability, voiceSimilarity, voiceStyle, voiceSpeed)}
                style={styles.slider}
              />
            </div>
          ))}
        </div>

        <div style={styles.divider} />

        <div style={styles.section}>
          <div style={styles.sectionLabel}>voice input</div>
          <div style={styles.toggleRow} onClick={toggleVoiceAutoSend}>
            <div style={styles.toggleInfo}>
              <div style={styles.toggleTitle}>auto-send after voice</div>
              <div style={styles.toggleHint}>
                {voiceAutoSend ? 'transcribed voice messages send instantly' : 'transcribed text fills the input so you can review first'}
              </div>
            </div>
            <div style={{ ...styles.toggleSwitch, background: voiceAutoSend ? 'linear-gradient(135deg, #8a5f35, #c9935a)' : 'rgba(201,147,90,0.12)' }}>
              <div style={{ ...styles.toggleKnob, transform: voiceAutoSend ? 'translateX(20px)' : 'translateX(0px)' }} />
            </div>
          </div>
        </div>

        <div style={styles.divider} />

        <div style={styles.section}>
          <div style={styles.sectionLabel}>memory</div>
          <div style={styles.toggleRow} onClick={toggleMemory}>
            <div style={styles.toggleInfo}>
              <div style={styles.toggleTitle}>remember our conversations</div>
              <div style={styles.toggleHint}>
                {memoryEnabled ? 'they build long-term memory of you across chats' : 'they start fresh — nothing is saved between chats'}
              </div>
            </div>
            <div style={{ ...styles.toggleSwitch, background: memoryEnabled ? 'linear-gradient(135deg, #8a5f35, #c9935a)' : 'rgba(201,147,90,0.12)' }}>
              <div style={{ ...styles.toggleKnob, transform: memoryEnabled ? 'translateX(20px)' : 'translateX(0px)' }} />
            </div>
          </div>
        </div>

        <div style={styles.divider} />

        <div style={styles.section}>
          <div style={styles.memoriesHeader}>
            <div style={styles.sectionLabel}>what they remember</div>
            {memoriesLoaded && <div style={styles.memoriesCount}>{memories.length} memories</div>}
          </div>
          {!memoriesLoaded && (
            <button style={{ ...styles.loadMemoriesBtn, opacity: loadingMemories ? 0.6 : 1 }} onClick={fetchMemories} disabled={loadingMemories}>
              {loadingMemories ? 'loading… ♡' : 'load memories ♡'}
            </button>
          )}
          {memoriesLoaded && (
            <>
              <div style={styles.memoriesList}>
                {memories.length === 0 && <div style={styles.noMemories}>no memories yet — start chatting 🥀</div>}
                {memories.map((m, i) => (
                  <div key={i} style={styles.memoryItem}>
                    <div style={styles.memoryDot} />
                    <div style={styles.memoryText}>{m.memory || m.text || JSON.stringify(m)}</div>
                    <button style={styles.memoryDelete} onClick={() => deleteMemory(m.id, i)}>✕</button>
                  </div>
                ))}
              </div>
              <button style={styles.dangerBtn} onClick={clearMemories}>clear all memories</button>
            </>
          )}
        </div>

        <div style={styles.divider} />

        <div style={styles.section}>
          <div style={styles.sectionLabel}>analytics</div>
          <button style={styles.statsBtn} onClick={() => navigate(`/stats/${companionId}`)}>view stats ♡</button>
        </div>

        <div style={styles.divider} />

        <div style={styles.section}>
          <div style={styles.sectionLabel}>danger zone</div>
          {!confirmDelete ? (
            <button style={styles.deleteBtn} onClick={() => setConfirmDelete(true)}>delete companion</button>
          ) : (
            <div style={styles.confirmWrap}>
              <div style={styles.confirmText}>this will permanently delete {companionName} and all their messages. are you sure?</div>
              <div style={styles.confirmActions}>
                <button style={styles.cancelDeleteBtn} onClick={() => setConfirmDelete(false)}>cancel</button>
                <button style={styles.confirmDeleteBtn} onClick={deleteCompanion}>yes, delete</button>
              </div>
            </div>
          )}
        </div>

      </div>

      {toast && <div style={styles.toast}>{toast}</div>}
    </div>
  );
}

const styles = {
  container: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: '#0e0b0f', fontFamily: "'DM Sans', sans-serif", display: 'flex', flexDirection: 'column' },
  header: { padding: '24px 28px 20px', background: 'linear-gradient(180deg, #120f18 0%, #0e0b0f 100%)', borderBottom: '1px solid rgba(201,147,90,0.08)', display: 'flex', alignItems: 'center', gap: '14px', flexShrink: 0 },
  backBtn: { width: '36px', height: '36px', borderRadius: '50%', border: '1px solid rgba(201,147,90,0.15)', background: 'transparent', color: '#c9935a', fontSize: '16px', cursor: 'pointer' },
  headerTitle: { fontFamily: "'Cormorant Garamond', serif", fontSize: '22px', color: '#e8ddd0', fontWeight: '300', fontStyle: 'italic' },
  content: { flex: 1, overflowY: 'auto', padding: '28px 28px 80px', display: 'flex', flexDirection: 'column', gap: '24px' },
  section: { display: 'flex', flexDirection: 'column', gap: '10px' },
  sectionLabel: { fontSize: '10px', color: '#4a3d30', letterSpacing: '0.12em', textTransform: 'uppercase', fontWeight: '400', paddingLeft: '2px' },
  promptHint: { fontSize: '12px', color: '#4a3d30', fontWeight: '300', lineHeight: '1.6', paddingLeft: '2px' },
  companionCard: { background: '#1e1825', borderRadius: '20px', padding: '18px', display: 'flex', alignItems: 'center', gap: '16px', border: '1px solid rgba(201,147,90,0.08)' },
  avatarWrap: { position: 'relative', flexShrink: 0, cursor: 'pointer' },
  avatar: { width: '64px', height: '64px', borderRadius: '50%', background: 'linear-gradient(135deg, #3a2a1a, #5a3d20)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: "'Cormorant Garamond', serif", fontSize: '26px', color: '#c9935a', fontStyle: 'italic', boxShadow: '0 0 0 1px rgba(201,147,90,0.15), 0 4px 12px rgba(0,0,0,0.3)', overflow: 'hidden' },
  avatarImg: { width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%' },
  avatarUploadBtn: { position: 'absolute', bottom: 0, right: 0, width: '22px', height: '22px', borderRadius: '50%', background: 'linear-gradient(135deg, #8a5f35, #c9935a)', border: '2px solid #1e1825', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '10px' },
  companionInfo: { flex: 1 },
  nameInput: { background: 'transparent', border: 'none', borderBottom: '1px solid rgba(201,147,90,0.2)', outline: 'none', fontFamily: "'Cormorant Garamond', serif", fontSize: '20px', color: '#e8ddd0', fontWeight: '300', width: '100%', paddingBottom: '4px', marginBottom: '6px' },
  companionSub: { fontSize: '12px', color: '#4a3d30', fontWeight: '300' },
  promptBox: { background: '#1e1825', borderRadius: '16px', border: '1px solid rgba(201,147,90,0.1)', padding: '16px 18px', fontFamily: "'DM Sans', sans-serif", fontSize: '14px', fontWeight: '300', color: '#e8ddd0', lineHeight: '1.7', width: '100%', minHeight: '120px', resize: 'none', outline: 'none' },
  saveBtn: { width: '100%', padding: '15px', borderRadius: '14px', border: 'none', background: 'linear-gradient(135deg, #8a5f35, #c9935a)', color: '#0e0b0f', fontFamily: "'DM Sans', sans-serif", fontSize: '13px', cursor: 'pointer', boxShadow: '0 6px 16px rgba(201,147,90,0.25)' },
  divider: { height: '1px', background: 'rgba(201,147,90,0.06)' },
  modelWrap: { position: 'relative' },
  modelSelect: { width: '100%', background: '#1e1825', borderRadius: '16px', border: '1px solid rgba(201,147,90,0.1)', padding: '14px 18px', fontFamily: "'DM Sans', sans-serif", fontSize: '13px', color: '#e8ddd0', outline: 'none', cursor: 'pointer', appearance: 'none', WebkitAppearance: 'none' },
  modelArrow: { position: 'absolute', right: '16px', top: '50%', transform: 'translateY(-50%)', color: '#4a3d30', fontSize: '12px', pointerEvents: 'none' },
  voiceRow: { display: 'flex', gap: '10px' },
  voiceInput: { flex: 1, background: '#1e1825', borderRadius: '16px', border: '1px solid rgba(201,147,90,0.1)', padding: '14px 18px', fontFamily: "'DM Sans', sans-serif", fontSize: '13px', color: '#e8ddd0', outline: 'none' },
  voiceSaveBtn: { padding: '14px 20px', borderRadius: '16px', border: 'none', background: 'linear-gradient(135deg, #8a5f35, #c9935a)', color: '#0e0b0f', fontFamily: "'DM Sans', sans-serif", fontSize: '13px', cursor: 'pointer', whiteSpace: 'nowrap' },
  toggleRow: { background: '#1e1825', borderRadius: '16px', border: '1px solid rgba(201,147,90,0.1)', padding: '16px 18px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '16px', cursor: 'pointer' },
  toggleInfo: { flex: 1 },
  toggleTitle: { fontSize: '14px', color: '#e8ddd0', fontWeight: '300', marginBottom: '4px' },
  toggleHint: { fontSize: '12px', color: '#4a3d30', fontWeight: '300', lineHeight: '1.5' },
  toggleSwitch: { width: '44px', height: '24px', borderRadius: '12px', flexShrink: 0, padding: '2px', transition: 'background 0.2s', display: 'flex', alignItems: 'center' },
  toggleKnob: { width: '20px', height: '20px', borderRadius: '50%', background: '#e8ddd0', transition: 'transform 0.2s', boxShadow: '0 1px 3px rgba(0,0,0,0.3)' },
  memoriesHeader: { display: 'flex', alignItems: 'center', justifyContent: 'space-between' },
  memoriesCount: { fontSize: '11px', color: '#8a5f35', fontWeight: '300' },
  loadMemoriesBtn: { width: '100%', padding: '14px', borderRadius: '14px', border: '1px solid rgba(201,147,90,0.15)', background: 'transparent', color: '#8a5f35', fontFamily: "'DM Sans', sans-serif", fontSize: '13px', cursor: 'pointer' },
  memoriesList: { display: 'flex', flexDirection: 'column', gap: '8px' },
  noMemories: { fontSize: '13px', color: '#4a3d30', textAlign: 'center', padding: '20px', fontWeight: '300' },
  memoryItem: { background: '#1e1825', borderRadius: '14px', border: '1px solid rgba(201,147,90,0.08)', padding: '12px 16px', display: 'flex', alignItems: 'flex-start', gap: '10px' },
  memoryDot: { width: '6px', height: '6px', borderRadius: '50%', background: '#8a5f35', flexShrink: 0, marginTop: '5px' },
  memoryText: { flex: 1, fontSize: '13px', color: '#7a6a5a', fontWeight: '300', lineHeight: '1.5' },
  memoryDelete: { width: '24px', height: '24px', borderRadius: '50%', border: 'none', background: 'transparent', color: '#4a3d30', cursor: 'pointer', fontSize: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 },
  dangerBtn: { width: '100%', padding: '14px', borderRadius: '14px', border: '1px solid rgba(201,147,90,0.12)', background: 'transparent', color: '#4a3d30', fontFamily: "'DM Sans', sans-serif", fontSize: '13px', cursor: 'pointer' },
  statsBtn: { width: '100%', padding: '14px', borderRadius: '14px', border: '1px solid rgba(201,147,90,0.15)', background: 'transparent', color: '#8a5f35', fontFamily: "'DM Sans', sans-serif", fontSize: '13px', cursor: 'pointer' },
  deleteBtn: { width: '100%', padding: '14px', borderRadius: '14px', border: '1px solid rgba(201,147,90,0.12)', background: 'transparent', color: '#4a3d30', fontFamily: "'DM Sans', sans-serif", fontSize: '13px', cursor: 'pointer' },
  confirmWrap: { background: '#1e1825', borderRadius: '16px', border: '1px solid rgba(201,147,90,0.08)', padding: '16px 18px', display: 'flex', flexDirection: 'column', gap: '14px' },
  confirmText: { fontSize: '13px', color: '#7a6a5a', fontWeight: '300', lineHeight: '1.6' },
  confirmActions: { display: 'flex', gap: '10px' },
  cancelDeleteBtn: { flex: 1, padding: '12px', borderRadius: '12px', border: '1px solid rgba(201,147,90,0.15)', background: 'transparent', color: '#4a3d30', fontFamily: "'DM Sans', sans-serif", fontSize: '13px', cursor: 'pointer' },
  confirmDeleteBtn: { flex: 1, padding: '12px', borderRadius: '12px', border: '1px solid rgba(201,147,90,0.12)', background: 'transparent', color: '#8a5f35', fontFamily: "'DM Sans', sans-serif", fontSize: '13px', cursor: 'pointer' },
  sliderWrap: { display: 'flex', flexDirection: 'column', gap: '8px', background: '#1e1825', borderRadius: '16px', border: '1px solid rgba(201,147,90,0.1)', padding: '14px 18px' },
  sliderHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  sliderLabel: { fontSize: '13px', color: '#e8ddd0', fontWeight: '300', fontFamily: "'DM Sans', sans-serif" },
  sliderValue: { fontSize: '13px', color: '#c9935a', fontWeight: '400', fontFamily: "'DM Sans', sans-serif", minWidth: '44px', textAlign: 'right' },
  slider: { width: '100%', appearance: 'none', WebkitAppearance: 'none', height: '4px', borderRadius: '2px', background: 'linear-gradient(90deg, #8a5f35, #c9935a)', outline: 'none', cursor: 'pointer' },
  toast: { position: 'fixed', bottom: '32px', left: '50%', transform: 'translateX(-50%)', background: 'rgba(201,147,90,0.15)', border: '1px solid rgba(201,147,90,0.3)', color: '#c9935a', padding: '10px 24px', borderRadius: '20px', fontSize: '13px', whiteSpace: 'nowrap', zIndex: 100 },
};

export default ChatSettings;
